module.exports = __webpack_public_path__ + "static/media/shapes_03.33c5e794.svg";